module.exports = __webpack_public_path__ + "assets/images/H-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/H-icon.png
// module id = 80
// module chunks = 1